import AboutHeader from "@/components/AboutHeader";
import LayoutFooter, { getFooterDataSource } from "@/components/LayoutFooter";
import useAppStore from "@/context/store";
import { getGrocery } from "@/services";
import { openUdesk } from "@/utils/initUdesk";
import useRequest from "@/utils/useReq";
import { Button } from "antd";
import Head from "next/head";
import { useState } from "react";
import styles from "./index.module.less";

const replaceEmail = (content, email) => {
  // eslint-disable-next-line no-template-curly-in-string
  return content.split("${email}").reduce((result, text, index) => {
    if (index !== 0) {
      result.push(
        <a key={`email${index}`} href={`mailto:${email}`}>
          {email}
        </a>
      );
    }
    if (text) {
      result.push(<span key={`text${index}`}>{text}</span>);
    }
    return result;
  }, []);
};

export async function getServerSideProps({ req, query }) {
  const dataSource = await getFooterDataSource({
    query,
    seoLinkInfo: {
      currentUrl: req.url,
    },
  });
  return {
    props: {
      footerDataSource: dataSource,
    },
  };
}

export default function Contact({ footerDataSource }) {
  const [data, setData] = useState(null);
  const { headerHeight } = useAppStore(({ headerHeight }) => ({
    headerHeight,
  }));

  useRequest(async () => {
    const data = await getGrocery("about-contact");
    setData(data);
  });

  return (
    <div className={styles.contact}>
      <Head>
        <title>联系我们-花瓣</title>
        <meta
          name="description"
          content="用花瓣网收集和分享你喜欢的一切。使用花瓣网采集工具，你可以方便保存任意网页上的图片、视频或视频和截图。"
        ></meta>
        <meta name="keywords" content="关于花瓣"></meta>
      </Head>
      <div
        className={styles.container}
        style={{ minHeight: `calc(100vh - ${headerHeight}px - 33px)` }}
      >
        <AboutHeader />
        <div className={styles.banner}>
          <div className={styles.left}>
            <div className={styles.info}>
              <h1>{data?.title}</h1>
              <p>{data?.content}</p>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.card}>
              <div className={styles.item}>
                <div className={styles.title}>{data?.column1?.title}</div>
                <div className={styles.content}>
                  {replaceEmail(
                    data?.column1?.content || "",
                    data?.column1?.email || ""
                  )}
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.title}>{data?.column2?.title}</div>
                <div className={styles.content}>
                  {replaceEmail(
                    data?.column2?.content || "",
                    data?.column2?.email || ""
                  )}
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.title}>{data?.column3?.title}</div>
                <div className={styles.content}>
                  {replaceEmail(
                    data?.column3?.content || "",
                    data?.column3?.email || ""
                  )}
                </div>
              </div>
              <div className={styles.item}>
                <div className={styles.title}>{data?.column4?.title}</div>
                <div className={styles.content}>
                  {replaceEmail(
                    data?.column4?.content || "",
                    data?.column4?.email || ""
                  )}
                </div>
                <div className={styles.action}>
                  {data?.button?.map((item) => {
                    if (item.url === "udesk") {
                      return (
                        <Button
                          key={item.title}
                          className={styles.button}
                          size="small"
                          onClick={openUdesk}
                        >
                          {item.title}
                        </Button>
                      );
                    } else {
                      return (
                        <Button
                          key={item.title}
                          className={styles.button}
                          size="small"
                          href={item.url}
                          target="_blank"
                        >
                          {item.title}
                        </Button>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LayoutFooter dataSource={footerDataSource} />
    </div>
  );
}
